import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '@src/layout-components/page';
import Home from '@src/ui-components/home';

const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());

  return (
    <Page className={styles.root}>
      <Home onNavToList={store.navToList} />
    </Page>
  );
};

export default observer(Main);
